



























































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ViewTermosDeUso extends Vue {
  isModalOpen = true
  pdfUrl = 'https://finxstsfrontstaticfiles.blob.core.windows.net/termos-e-condicoes-de-uso/Termos%20e%20Condi%C3%A7%C3%B5es%20de%20Uso.pdf'

  closeModal(): void {
    this.isModalOpen = false
    this.pdfUrl = ''
  }

  handleBackdropClick(event: MouseEvent): void {
    const target = event.target as HTMLElement
    if (target.classList.contains('modal')) {
      this.closeModal()
    }
  }
}
